import {TicketStatusCategory} from '@frontapp/ticketing';
import * as t from 'io-ts';

import {RTagIdRef} from './apiTypes';
import {IotsType} from './commonApiTypes';
import {makeEnumTypeGuard, makeSafeEnumRuntimeType} from './types/enumTypes';

/*
 * Runtime types.
 */

export const isTicketStatusCategory = makeEnumTypeGuard(TicketStatusCategory);

export const RTicketStatusCategory = makeSafeEnumRuntimeType(TicketStatusCategory, TicketStatusCategory.OPEN);

export const RTicketStatus = t.type({
  category: RTicketStatusCategory,
  tagId: RTagIdRef,
});

/*
 * Types.
 */

export interface TicketStatusModel extends IotsType<typeof RTicketStatus> {}

/*
 * Serialization/deserialization.
 */

export function parseTicketStatus(src: any): TicketStatusModel {
  return {
    category: src.category,
    tagId: src.tag_id,
  };
}
